




















































































































































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Customer, Inspector, Maintenancejob, Property } from "@/models";
import JobDetailsTab from "@/pages/jobs/tabs/JobDetails.vue";
import Photos from "@/components/photo/Photos.vue";
import { DxDateBox } from "devextreme-vue/date-box";

@Component({
  components: {
    JobDetailsTab,
    Photos,
    DxDateBox,
  },
})
export default class JobDetails extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("maintenancejobs/hasUnsavedChanges")
  public hasUnsavedChanges: boolean;
  @Getter("auth/isBaseUser") public isBaseUser: boolean;
  @Getter("auth/isAdministrator") public isAdministrator: boolean;
  @Getter("customers/list") public customerlist: Customer[];
  @Getter("inspectors/list") public inspectorlist: Inspector[];

  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];

  @Getter("maintenancejobs/list") public maintenancejoblist: Maintenancejob[];

  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;
  public customerOptions: { value: string; label: string }[] = [];
  public inspectorOptions: { value: string; label: string }[] = [];
  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  @Action("maintenancejobs/addMaintenancejob")
  public addMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;

  @Action("maintenancejobs/updateMaintenancejob")
  public updateMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;
  @Action("customers/getCustomers") getCustomers: () => Promise<void>;
  @Action("inspectors/getInspectors") getInspectors: () => Promise<void>;
  public async mounted() {
    if (this.customerlist.length == 0) {
      await Promise.all([this.getCustomers()])
        .then(() => {
          this.setCustomerOptions();
        })
        .catch((err: any) => this.$onecentral.displayError(err));
    } else {
      this.setCustomerOptions();
    }
    if (this.inspectorlist.length == 0) {
      await Promise.all([this.getInspectors()])
        .then(() => {
          this.setInspectorOptions();
        })
        .catch((err: any) => this.$onecentral.displayError(err));
    } else {
      this.setInspectorOptions();
    }
  }
  public async setCustomerOptions() {
    this.customerOptions = Array.from(this.customerlist).map((b) => ({
      value: b.id,
      label: b.companyName,
    }));
  }
  public async setInspectorOptions() {
    this.inspectorOptions = Array.from(this.inspectorlist).map((b) => ({
      value: b.id,
      label: b.companyName,
    }));
  }
  get addressLine1() {
    return this.maintenancejob.address.line1;
  }
  set addressLine1(data) {
    this.setMaintenancejobDeep({ path: "address.line1", data });
  }
  public checkStatus(){
    return this.maintenancejob.invoice.fees.length && this.maintenancejob.invoice.fees.every(fee => fee.status === 'Completed');
  }

  get filtercustomer(): { value: string; label: string } | undefined {
    return this.customerOptions.find((x: { value: string; label: string }) => {
      return x.value === this.maintenancejob.customer.id;
    });
  }
  get filterinspector(): { value: string; label: string } | undefined {
    return this.inspectorOptions.find((x: { value: string; label: string }) => {
      return x.value === this.maintenancejob.inspector;
    });
  }

  get defectid() {
    return this.maintenancejob.defectid;
  }
  set defectid(data) {
    this.setMaintenancejobDeep({ path: "defectid", data });
  }

  get addressLine2() {
    return this.maintenancejob.address.line2;
  }
  set addressLine2(data) {
    this.setMaintenancejobDeep({ path: "address.line2", data });
  }

  get addressTown() {
    return this.maintenancejob.address.town;
  }
  set addressTown(data) {
    this.setMaintenancejobDeep({ path: "address.town", data });
  }

  get addressCounty() {
    return this.maintenancejob.address.county;
  }
  set addressCounty(data) {
    this.setMaintenancejobDeep({ path: "address.county", data });
  }

  get addressPostcode() {
    return this.maintenancejob.address.postcode;
  }
  set addressPostcode(data) {
    this.setMaintenancejobDeep({ path: "address.postcode", data });
  }
  get quotationtoggle() {
    return this.maintenancejob.quotationtoggle;
  }
  set quotationtoggle(data) {
    this.setMaintenancejobDeep({ path: "quotationtoggle", data });
  }

  public setBooleanValue(val: boolean) {
    this.setMaintenancejobDeep({ path: "quotationtoggle", data: val });
  }

  public statusOptions: string[] = [
    "New",
    "Unallocated",
    "Allocated",
    "In Progress",
    "On Hold",
    "Completed",
  ];

  get photos() {
    return this.maintenancejob.photos;
  }
  set photos(data) {
    this.setMaintenancejobDeep({ path: "photos", data });
  }
  get completiondate() {
    return this.maintenancejob.completiondate;
  }
  set completiondate(data) {
    this.setMaintenancejobDeep({ path: "completiondate", data });
  }

  get createdate() {
    return this.maintenancejob.createdate;
  }
  set createdate(data) {
    this.setMaintenancejobDeep({ path: "createdate", data });
  }

  get targetdate() {
    return this.maintenancejob.targetdate;
  }
  set targetdate(data) {
    this.setMaintenancejobDeep({ path: "targetdate", data });
  }
  public onCustomerSelect(selected: { value: string; label: string }) {
    if (selected !== null) {
      this.setMaintenancejobDeep({
        path: "customer.id",
        data: selected.value,
      });
    }
  }
  public onInspectorSelect(selected: { value: string; label: string }) {
    if (selected !== null) {
      this.setMaintenancejobDeep({
        path: "inspector",
        data: selected.value,
      });
    }
  }
}
